var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "man",
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.615,
    height: 48.221,
    viewBox: "0 0 34.615 48.221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3254",
    "data-name": "Path 3254",
    d: "M124.112,19.2s-3.4-10.488,1.034-12.408c.443-2.437,2.074-2.733,2.883-3.1.366-1.034,2.286-3.324,7.826-2.954S141.395.665,142.724,0c.148,1.182,3.812,2.511,2.238,6.795,1.307.222,2.68,3.947.516,11.243-4.306,0-21.367,1.166-21.367,1.166Z",
    transform: "translate(-117.613 0)",
    fill: "#240703"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1885",
    "data-name": "Group 1885",
    transform: "translate(4.977 18.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3255",
    "data-name": "Path 3255",
    d: "M346.166,193.34l.788-2.522a1.849,1.849,0,0,1,2.119,1.107c.732,1.492-1.183,4.558-2.835,4.816A8.407,8.407,0,0,1,346.166,193.34Z",
    transform: "translate(-324.649 -190.773)",
    fill: "#e09f67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3256",
    "data-name": "Path 3256",
    d: "M123,193.34l-.788-2.522a1.849,1.849,0,0,0-2.119,1.107c-.732,1.492,1.183,4.558,2.835,4.816A8.4,8.4,0,0,0,123,193.34Z",
    transform: "translate(-119.932 -190.773)",
    fill: "#e09f67"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3257",
    "data-name": "Path 3257",
    d: "M191.422,303.349h11.163v11.588H191.422Z",
    transform: "translate(-184.666 -292.71)",
    fill: "#f6bd8c"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1886",
    "data-name": "Group 1886",
    transform: "translate(11.675 28.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3258",
    "data-name": "Path 3258",
    d: "M190.8,303.349v1.889s2.187,4.993,6.6,4.993a6.668,6.668,0,0,0,4.565-1.7v-5.185H190.8Z",
    transform: "translate(-190.801 -303.349)",
    fill: "#ce8a57"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3259",
    "data-name": "Path 3259",
    d: "M163.123,80.343q.005-.158.005-.316c0-6.55,1.911-13.94-9.716-14.049l-.26,0-.26,0c-11.628.109-9.716,7.5-9.716,14.049q0,.158.005.316c0,.105-.012,4.875.708,6.093s4.985,6.788,9.029,6.788c0,0,.471,0,.475,0,4.044,0,8.309-5.569,9.029-6.788s.708-6.093.708-6.093Z",
    transform: "translate(-135.895 -59.74)",
    fill: "#f6bd8c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3260",
    "data-name": "Path 3260",
    d: "M101.8,393.563c-.208-5.176-4.191-6.372-6.583-6.621-.657-.069-2.59-.066-3.922-.054v0c-.773.006-1.345.016-1.345.016-.1,1.733-2.16,2.662-5.38,2.725-3.219-.062-5.556-1.383-5.556-2.725,0,0-.518-.009-1.23-.015v0c-1.281-.012-3.194-.016-3.861.054-2.392.249-6.375,1.445-6.583,6.621a16.622,16.622,0,0,0,0,3.135s5.822,1.782,16.824,1.841c.082,0,.726,0,.808,0,11-.059,16.824-1.841,16.824-1.841A16.622,16.622,0,0,0,101.8,393.563Z",
    transform: "translate(-67.264 -350.32)",
    fill: "#15afbf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3261",
    "data-name": "Path 3261",
    d: "M232.615,428.97l-1.824,2.082.92,5.6h1.81l.92-5.6Z",
    transform: "translate(-215.337 -388.431)",
    fill: "#091e26"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3262",
    "data-name": "Path 3262",
    d: "M236.612,407.5a1.409,1.409,0,0,0-1.567-1.306h0a1.409,1.409,0,0,0-1.567,1.306,2.061,2.061,0,0,0,1.415,1.757.885.885,0,0,0,.308,0A2.061,2.061,0,0,0,236.612,407.5Z",
    transform: "translate(-217.767 -367.809)",
    fill: "#091e26"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3263",
    "data-name": "Path 3263",
    d: "M250.1,370.151l5.618-3.736,1.243,1.929L253.527,373Z",
    transform: "translate(-232.818 -331.788)",
    fill: "#29ced6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3264",
    "data-name": "Path 3264",
    d: "M184.353,370.151l-5.545-3.736-1.316,1.929L180.923,373Z",
    transform: "translate(-167.075 -331.788)",
    fill: "#29ced6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3265",
    "data-name": "Path 3265",
    d: "M156.38,70.19c0-3.25,2.036-12.595-10.638-12.595s-10.728,10.854-10.728,12.7c0,0,1.227-.733,1.315,1.713.383-.065.454-.789.382-1.9s0-5.3,0-5.3a14.381,14.381,0,0,0,1.774-3.714c.886-.074,3.965,2.585,14.169,1.182,1.155.786,2.744,2.533,2.276,9.562-.014.209.19.179.309.179C155.612,70.516,155.784,70.138,156.38,70.19Z",
    transform: "translate(-128.514 -52.152)",
    fill: "#240703"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.97934746cd65512fbb863598feb85fae.svg";
export { ForwardRef as ReactComponent };